"use client";

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useAdmin } from '@/context/AdminContext';
import styles from './NavAdmin.module.css';

const onglets = [
  { label: "Membres",       href: "/admin/membres" },
  { label: "Configuration", href: "/admin/configuration" },
  { label: "Bibliothèque",  href: "/admin/bibliotheque" },
  { label: "Statistiques",  href: "/admin/statistiques" },
  { label: "Catégories",    href: "/admin/categories" },
  { label: "Initiatives",   href: "/admin/initiatives" },
  { label: "Sources",       href: "/admin/sources" },
];

export default function NavAdmin() {
  const { isAdmin } = useAdmin();
  const pathname = usePathname();

  if (!isAdmin) return null;

  return (
    <nav className={styles.nav}>
      {onglets.map(o => (
        <Link
          key={o.href}
          href={o.href}
          className={`${styles.onglet} ${pathname.startsWith(o.href) ? styles.actif : ''}`}
        >
          {o.label}
        </Link>
      ))}
    </nav>
  );
}
